import { EyeOutlined, LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Table,
  Empty,
  Button,
  Input,
  notification,
  Modal,
  Select,
} from "antd";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { exportState } from "../../../utils/exportState";
import { Dropdown } from "semantic-ui-react";
import { ModalExportacion } from "../../../components/Administrador/ModalExportacion/ModalExportacion";
import { useProyectos } from "../../../hooks/useProyectos";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { ModalBeneficiarios } from "./modal-beneficiarios";
import { VerMasProyectos } from "./VerMasProyectos";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import apiDocumentos from "../../../api/Documentos/api-documentos";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import apiMaestras from "../../../api/Maestras/api-maestras";
import apiJurados from "../../../api/Jurados/api-jurados";
import { TemplateContext } from "../../../utils/template_context";
import {
  CHIPS_ESTADO_RESULTADO,
  CLAVE_TODAS,
  colorDeFondo,
  contarChipResultado,
  proyectosDelChip,
} from "../../../utils/chipsEstadoResultado";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
import JSZip from "jszip";
import { generarPlanillaPDF, runWithConcurrency } from "./generarPlanillaPDF";

// Planillas por archivo ZIP. Con líneas de ~1000 hojas de vida, armar un solo ZIP agota la memoria
// del navegador justo al comprimir, así que la exportación se parte en varios archivos.
const TAMANO_LOTE_PLANILLAS = 200;

const TituloColumnaVer = () => (
  <Row>
    <Col span={24} className="justify-content-center">
      Ver
    </Col>
  </Row>
);

const nombreZipLote = (prefijo: string, indice: number, total: number): string =>
  total > 1 ? `${prefijo}_${indice + 1}_de_${total}.zip` : `${prefijo}.zip`;

const crearLotes = (items: any[]): any[][] => {
  const lotes: any[][] = [];
  for (let i = 0; i < items.length; i += TAMANO_LOTE_PLANILLAS) {
    lotes.push(items.slice(i, i + TAMANO_LOTE_PLANILLAS));
  }
  return lotes;
};

// Datos de la convocatoria que se reutilizan en toda la exportación: fecha del informe de
// evaluación y línea de convocatoria del Banco de Jurados.
type DatosConvocatoria = { informe: string; linea: string };
const SIN_CONVOCATORIA: DatosConvocatoria = { informe: '', linea: '' };

export const HojasdeVida = () => {
  let {
    proyectos,

    cambiarCantidadPaginas,
    cantidadPaginas,
    obtenerProyectos,
    loading,
    filtros,
    setFiltros,
    burcarFiltrosJurados
  } = useProyectos();
  // Chip de estado seleccionado encima de la tabla. Empieza en Total, que no
  // filtra nada.
  const [chipActivo, setChipActivo] = useState<string>(CLAVE_TODAS);
  const [paginaActual, setPaginaActual] = useState<number>(1);

  const alternarChip = (clave: string) => {
    // Volver a tocar el chip encendido quita el filtro.
    setChipActivo((actual) => (actual === clave ? CLAVE_TODAS : clave));
    setPaginaActual(1);
  };

  // Los numeros se cuentan sobre la lista completa, no sobre lo que se esta
  // mostrando, para que al filtrar por un chip los demas no se vayan a cero.
  const proyectosMostrados = proyectosDelChip(proyectos, chipActivo);

  useEffect(() => {
    // Una busqueda nueva empieza en la primera pagina.
    setPaginaActual(1);
  }, [proyectos]);

  const ref = useRef<any>();

  // colors state of postulation
  const coloresEstado: any = {
    Aceptado: "#00904C",
    "Por evaluar": "#F28C02",
    "Evaluado": "#6435C9"
  };
  const context = useContext(TemplateContext);
  const columns: any = [
    {
      title: "No.",
      width: 40,
      fixed: context.device === "lg" ? "left" : false,
      key: "index",
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 80,
      render: (data: any) => <span style={{ color: coloresEstado[data?.estado] }}>{data?.estado}</span>,
    },
    {
      title: "Documento",
      width: 100,
      render: (data: any) => <span>{data?.postulacion?.numero_documento_participante}</span>,
    },
    {
      title: "Puntaje final",
      width: 100,
      whiteSpace: "nowrap",
      className: "white-space-nowrap",
      style: { whiteSpace: "nowrap" },
      render: (data: any) => <span>{data?.postulacion?.nota_final}</span>,
      fixed: context.device === "lg" ? "right" : false,
    },
    {
      title: TituloColumnaVer,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
          <Row>
            <Col span={24} className="justify-content-center">
              <EyeOutlined
                onClick={() => verMas(datos)}
              />
            </Col>
          </Row>
      ),
    },
    /*{
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Seleccionar
          </Col>
        </Row>
      ),
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, idx: number) => (
        <>
          {datos.estado !== "Beneficiario" && (
            <Row className="width-100">
              <Col span={24} className="justify-content-center items-align-center mb-0 ">
                <Form ref={ref}>
                  <Form.Item name="select" className="mb-0 align-items-center">
                    <Checkbox
                      checked={datos.checked}
                      onChange={(e) => addProyectos(e.target.checked, datos)}
                    ></Checkbox>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          )}
        </>
      ),
    },*/
  ];

  const [verMasOpen, setVerMasOpen] = useState(false);
  const [datos, setDatos] = useState({
    nombre_propuesta: "",
    radicado: "",
    jurados: [],
  });

  const nombreCompleto = (jurado: any): string =>
    [jurado?.primer_nombre, jurado?.segundo_nombre, jurado?.primer_apellido, jurado?.segundo_apellido]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();

  // Nombre completo de quien presentó la hoja de vida. Se busca primero en participantes, que está
  // en la misma base que las postulaciones; si no aparece, en la tabla de jurados por documento y
  // por radicado (esta última exige que el jurado esté marcado como completado, así que no siempre
  // devuelve resultados).
  const nombreJurado = async (fila: any): Promise<string> => {
    const documento = fila?.postulacion?.numero_documento_participante;

    if (documento) {
      try {
        const participante: any = await apiParticipantes.consultarParticipante(documento);
        const nombre = nombreCompleto(participante?.data);
        if (nombre) return nombre;
      } catch (error) {
        console.error(`[Hojas de vida] No se pudo consultar el participante ${documento}:`, error);
      }

      try {
        const jurado: any = await apiJurados.obetenerJuradoDocumento(documento);
        const nombre = nombreCompleto(jurado);
        if (nombre) return nombre;
      } catch (error) {
        console.error(`[Hojas de vida] No se pudo consultar el jurado con documento ${documento}:`, error);
      }
    }

    try {
      const respuesta: any = await apiJurados.obetenerJuradoRadicado(fila?.radicado);
      const juries: any[] = respuesta?.juries || [];
      return nombreCompleto(juries.find((j: any) => j.radicado === fila?.radicado) || juries[0]);
    } catch (error) {
      console.error(`[Hojas de vida] No se pudo consultar el jurado de ${fila?.radicado}:`, error);
      return "";
    }
  };

  // El maestro de líneas de convocatoria se consulta una sola vez y se comparte entre la vista y la
  // exportación masiva.
  const maestroLineasRef = useRef<Promise<any[]> | null>(null);
  const maestroLineas = (): Promise<any[]> => {
    if (maestroLineasRef.current !== null) return maestroLineasRef.current;

    const consulta = apiMaestras.obtenerLineaConvocatoria()
      .then((lineas: any) => (Array.isArray(lineas) ? lineas : []))
      .catch((error: any) => {
        console.error("[Hojas de vida] No se pudo consultar el maestro de líneas de convocatoria:", error);
        return [];
      });
    maestroLineasRef.current = consulta;
    return consulta;
  };

  // La convocatoria guarda el id de la línea; el nombre está en el maestro de líneas, igual que en
  // getFilterLineaConvocatoria de las tablas de convocatorias.
  const nombreLinea = (idLinea: any, lineas: any[]): string =>
    lineas.find((l: any) => String(l.id) === String(idLinea))?.nombre || "";

  // Línea de la convocatoria del Banco de Jurados (p. ej. "Banco de jurados Cultura Medellín 2026"),
  // que vive en la convocatoria, no en la postulación.
  const lineaConvocatoria = async (convocatoriaId: any): Promise<string> => {
    if (!convocatoriaId) return "";
    try {
      const [convocatoria, lineas] = await Promise.all([
        apiConvocatorias.getConvocatoriaById(convocatoriaId),
        maestroLineas(),
      ]);
      return nombreLinea(convocatoria?.data?.linea_convocatoria, lineas);
    } catch (error) {
      console.error(`[Hojas de vida] No se pudo consultar la convocatoria ${convocatoriaId}:`, error);
      return "";
    }
  };

  // Las hojas de vida (radicado "J...") no tienen propuesta, línea ni categoría en la postulación:
  // el resultado de evaluación solo trae el radicado y el registro del jurado guarda esos campos en
  // null. La cabecera de la planilla se completa con el nombre de quien presentó la hoja de vida, la
  // línea de la convocatoria del Banco de Jurados y el área o expresión a la que se postuló.
  const completarDatosHojaVida = async (fila: any, linea?: string) => {
    if (fila?.nombre_propuesta && fila?.linea_convocatoria) return fila;

    const [nombre, lineaBanco] = await Promise.all([
      nombreJurado(fila),
      linea !== undefined ? Promise.resolve(linea) : lineaConvocatoria(fila?.postulacion?.convocatoria_id),
    ]);

    return {
      ...fila,
      esHojaDeVida: true,
      nombre_propuesta: fila.nombre_propuesta || nombre,
      linea_convocatoria: fila.linea_convocatoria || lineaBanco || "Banco de Jurados",
      categoria_linea_convocatoria: fila.categoria_linea_convocatoria || fila.postulacion?.area || "",
    };
  };

  const verMas = async (fila: any) => {
    setDatos({ ...fila, esHojaDeVida: true });
    setVerMasOpen(true);
    const completos = await completarDatosHojaVida(fila);
    setDatos((actual: any) => (actual?.radicado === completos?.radicado ? completos : actual));
  };

  const [proyectosBeneficiarios] = useState<any>([]);
  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  };

  /* **** MODAL **** */
  const opcionesSelect = [
    { id: 1, nombre: "Proyectos Beneficiarios", value: "Beneficiario" },
    { id: 2, nombre: "Proyectos No Beneficiarios", value: "No Beneficiario" },
  ];

  const [openModal, setOpenModal] = useState(false);
  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };

  const [openModalBeneficiarios, setOpenModalBeneficiarios] = useState(false);
  const [loadingPlanillas, setLoadingPlanillas] = useState(false);

  const descargarFirma = async (ruta: string): Promise<string | null> => {
    try {
      const firma = await apiDocumentos.consultarArchivo(ruta);
      if (firma?.data) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(firma.data);
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = () => resolve(null);
        });
      }
    } catch {
      return null;
    }
    return null;
  };

  // Los mismos jurados evalúan cientos de hojas de vida: sin caché se descargaría su firma una vez
  // por planilla.
  const firmasRef = useRef<Record<string, Promise<string | null>>>({});
  const firmaPorJurado = (jurado: any): Promise<string | null> => {
    if (!jurado?.firma) return Promise.resolve(null);
    const cacheada = firmasRef.current[jurado.firma];
    if (cacheada !== undefined) return cacheada;

    const descarga = descargarFirma(jurado.firma);
    firmasRef.current[jurado.firma] = descarga;
    return descarga;
  };

  const descargarZip = async (zip: any, nombreArchivo: string) => {
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const url = URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Un ZIP de cientos de planillas tarda en escribirse en disco: revocar la URL de inmediato puede
    // cortar la descarga.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };

  const procesarProyecto = async (
    proyecto: any,
    convocatoriaCache: Record<string, Promise<DatosConvocatoria>>
  ): Promise<Blob | null> => {
    const { data } = await apiParticipantes.obtenerJuradosCriterios(proyecto.id_postulacion);
    if (!data || data.length === 0) return null;

    const convocatoriaId = proyecto.postulacion?.convocatoria_id;
    if (convocatoriaId && convocatoriaCache[convocatoriaId] === undefined) {
      convocatoriaCache[convocatoriaId] = Promise.all([
        apiConvocatorias.getConvocatoriaById(convocatoriaId),
        maestroLineas(),
      ])
        .then(([convocatoria, lineas]) => {
          const linea = nombreLinea(convocatoria.data?.linea_convocatoria, lineas);
          for (const f of convocatoria.data.fechas) {
            if (f.clave === 'Informe de evaluación' && f.valormin) {
              const d = new Date(f.valormin);
              if (!isNaN(d.getTime())) {
                return { informe: d.toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' }), linea };
              }
            }
          }
          return { informe: '', linea };
        })
        .catch(() => SIN_CONVOCATORIA);
    }

    const [juradosConFirmas, convocatoria] = await Promise.all([
      Promise.all(data.map(async (jurado: any) => ({ ...jurado, src: await firmaPorJurado(jurado) }))),
      convocatoriaId ? convocatoriaCache[convocatoriaId] : Promise.resolve(SIN_CONVOCATORIA),
    ]);

    const datosPlanilla = await completarDatosHojaVida(proyecto, convocatoria.linea);

    return generarPlanillaPDF(datosPlanilla, juradosConFirmas, convocatoria.informe);
  };

  const [openModalLote, setOpenModalLote] = useState(false);
  const [loteInicial, setLoteInicial] = useState(1);
  const lotesPlanillas = useMemo(() => crearLotes(proyectos), [proyectos]);

  // Con una sola tanda se exporta directo; con varias se pregunta desde cuál archivo empezar, para
  // poder retomar una exportación que se interrumpió.
  const abrirExportacionPlanillas = () => {
    if (proyectos.length === 0) {
      openNotification({
        titulo: "Sin proyectos",
        descripcion: "No hay proyectos en la lista para exportar",
        placement: "bottomRight",
      });
      return;
    }
    if (lotesPlanillas.length <= 1) {
      planillas();
      return;
    }
    setLoteInicial(1);
    setOpenModalLote(true);
  };

  const confirmarExportacionPlanillas = () => {
    setOpenModalLote(false);
    planillas(loteInicial);
  };

  // Genera una planilla; registra el radicado en `omitidos` si no se pudo.
  const planillaDeProyecto = async (
    proyecto: any,
    convocatoriaCache: Record<string, Promise<DatosConvocatoria>>,
    omitidos: string[]
  ): Promise<{ radicado: string; blob: Blob } | null> => {
    try {
      const blob = await procesarProyecto(proyecto, convocatoriaCache);
      if (blob) return { radicado: proyecto.radicado, blob };
      omitidos.push(proyecto.radicado);
      console.warn(`[Planillas] Sin jurados: ${proyecto.radicado}`);
    } catch (err) {
      omitidos.push(proyecto.radicado);
      console.error(`[Planillas] Error en ${proyecto.radicado}:`, err);
    }
    return null;
  };

  // Genera las planillas de un lote y las empaqueta en un ZIP.
  const armarZipLote = async (
    lote: any[],
    convocatoriaCache: Record<string, Promise<DatosConvocatoria>>,
    omitidos: string[]
  ): Promise<{ zip: JSZip; generadas: number }> => {
    const resultados = await runWithConcurrency(
      lote,
      (proyecto: any) => planillaDeProyecto(proyecto, convocatoriaCache, omitidos),
      2
    );

    const zip = new JSZip();
    let generadas = 0;
    for (const res of resultados) {
      if (res) {
        zip.file(`${res.radicado}.pdf`, res.blob);
        generadas++;
      }
    }
    resultados.length = 0;
    return { zip, generadas };
  };

  const avisarOmitidos = (omitidos: string[]) => {
    if (omitidos.length === 0) return;
    const listado = omitidos.slice(0, 20).join(', ');
    const resto = omitidos.length > 20 ? ` y ${omitidos.length - 20} más (ver consola)` : '';
    notification.warning({
      message: `${omitidos.length} proyecto(s) sin planilla`,
      description: `Sin jurados asignados o con error: ${listado}${resto}`,
      placement: 'bottomRight',
      duration: 12,
    });
  };

  // `desdeLote` (1..n) permite retomar una exportación interrumpida sin repetir los ZIP ya
  // descargados. La numeración de los archivos es siempre absoluta, así que el archivo 6 se llama
  // igual se haya empezado desde el 1 o desde el 6.
  const planillas = async (desdeLote = 1) => {
    if (proyectos.length === 0) {
      openNotification({
        titulo: "Sin proyectos",
        descripcion: "No hay proyectos en la lista para exportar",
        placement: "bottomRight",
      });
      return;
    }

    setLoadingPlanillas(true);
    exportState.suppressRedirect = true;

    const convocatoriaCache: Record<string, Promise<DatosConvocatoria>> = {};

    try {
      const prefijo = (proyectos[0]?.radicado || 'planillas_evaluacion').split('-')[0].trim();
      const lotes = crearLotes(proyectos);

      const omitidos: string[] = [];
      let totalGenerados = 0;

      // Un ZIP por lote: cada uno se comprime, se descarga y se libera antes de seguir con el
      // siguiente, para no acumular en memoria las planillas de toda la línea.
      for (let i = desdeLote - 1; i < lotes.length; i++) {
        const yaListas = (desdeLote - 1) * TAMANO_LOTE_PLANILLAS + totalGenerados;
        notification.info({
          key: 'exportando-planillas',
          message: lotes.length > 1 ? `Exportando planillas (archivo ${i + 1} de ${lotes.length})` : 'Exportando planillas',
          description: `Procesando ${lotes[i].length} proyecto(s)... ${yaListas} de ${proyectos.length} listas.`,
          placement: 'bottomRight',
          duration: 0,
        });

        const { zip, generadas } = await armarZipLote(lotes[i], convocatoriaCache, omitidos);
        if (generadas === 0) continue;

        await descargarZip(zip, nombreZipLote(prefijo, i, lotes.length));
        totalGenerados += generadas;
        // El navegador descarta descargas automáticas muy seguidas.
        if (i < lotes.length - 1) await new Promise(resolve => setTimeout(resolve, 2000));
      }

      avisarOmitidos(omitidos);

      notification.success({
        key: 'exportando-planillas',
        message: 'Exportación completada',
        description: lotes.length > 1
          ? `Se generaron ${totalGenerados} planilla(s) en ${lotes.length} archivos ZIP`
          : `Se generaron ${totalGenerados} planilla(s)`,
        placement: 'bottomRight',
      });
    } catch (error: any) {
      console.error(error);
      notification.warning({
        key: 'exportando-planillas',
        message: 'Error al exportar',
        description: 'Ocurrió un error al iniciar la exportación. Verifica tu sesión e intenta de nuevo.',
        placement: 'bottomRight',
        duration: 8,
      });
    } finally {
      exportState.suppressRedirect = false;
      setLoadingPlanillas(false);
    }
  };
  const routes = [
    { nombre: "Gestión jurados" },
    { nombre: "Resultado evaluación" },
  ];

  return (
    <div className="background-color-F7FBFF h-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Resultados de Evaluación H.V
        </div>

        <div className="sombra_card" style={{ marginBottom: "20px" }}>
          <div>
            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Buscar{" "}
              </div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="row mb-3">
                  <div>
                    <div className="col-12 col-md-6 col-lg-3 mb-3">
                      <div>
                        <div className="col-12">
                          <span className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">
                            Filtrar código
                          </span>
                        </div>
                        <div className="col-12">
                          <Input
                            suffix={<SearchOutlined className="font-color-051923bf" />}
                            value={filtros.codigo}
                            placeholder="Buscar..."
                            onChange={(e) =>
                              setFiltros({ ...filtros, codigo: e.target.value })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-blanco-radius m-0"
                onClick={burcarFiltrosJurados}
                disabled={loading}
              >
                Buscar
              </Button>
            </div>
          </div>
        </div>

        <div
          className="row-shadow"
          style={{ marginBottom: "6%", marginTop: "16px" }}
        >
          <div className="col-12">
            <div className="row">
              <div className="my-scrollable-div col-12 col-md-12 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3" style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%' }}>
                {CHIPS_ESTADO_RESULTADO.map((chip) => {
                  const activo = chipActivo === chip.clave;
                  return (
                    <button
                      key={chip.clave}
                      type="button"
                      aria-pressed={activo}
                      title={
                        chip.estados === null
                          ? "Mostrar todas las hojas de vida"
                          : `Mostrar solo: ${chip.etiqueta}`
                      }
                      onClick={() => alternarChip(chip.clave)}
                      className={`d-flex justify-content-end mx-2 ${chip.clase}`}
                      style={{
                        flexShrink: 0,
                        font: "inherit",
                        color: "inherit",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        borderRadius: 16,
                        padding: "2px 10px",
                        border: `1px solid ${chip.color}`,
                        background: activo ? colorDeFondo(chip.color) : "transparent",
                        fontWeight: activo ? 600 : "normal",
                      }}
                    >
                      {chip.etiqueta} :{" "}
                      <span className={chip.claseNumero}>
                        &nbsp;{contarChipResultado(proyectos, chip.clave)}
                      </span>
                    </button>
                  );
                })}
                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <span className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </span>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadPaginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg />
                    }
                    onChange={(e, { value }) =>
                      cambiarCantidadPaginas(e, value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadPaginas,
                    current: paginaActual,
                    onChange: (pagina: number) => setPaginaActual(pagina),
                  }}
                  dataSource={proyectosMostrados}
                  columns={columns}
                  size="small"
                  bordered={false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer justify-content-flex-end">
        <div className="justify-content-flex-end">
        </div>
        <div className="justify-content-end">
          <Button className="button-azul-radius ms-1" onClick={abrirExportacionPlanillas} loading={loadingPlanillas} disabled={loadingPlanillas}>
            Exportar planillas
          </Button>
        </div>
      </div>

      {openModal && (
        <ModalExportacion
          openModal={openModal}
          setOpenModal={setOpenModal}
          opcionesSelect={opcionesSelect}
          modulo="Postulaciones"
          consulta="1"
        />
      )}

      {openModalBeneficiarios && (
        <ModalBeneficiarios
          openModal={openModalBeneficiarios}
          proyectosBeneficiarios={proyectosBeneficiarios.filter(
            (x: any) => x.checked === true
          )}
          setOpenModal={setOpenModalBeneficiarios}
          obtenerProyectos={obtenerProyectos}
          referencia={ref}
        />
      )}

      {verMasOpen && (
        <VerMasProyectos
          openModal={verMasOpen}
          setOpenModal={setVerMasOpen}
          datos={datos}
        />
      )}

      <Modal
        title={<span className="font-family-Monserrat-SemiBold font-size-14px">Exportar planillas</span>}
        visible={openModalLote}
        onCancel={() => setOpenModalLote(false)}
        footer={[
          <Button key="cancelar" className="button-blanco-radius" onClick={() => setOpenModalLote(false)}>
            Cancelar
          </Button>,
          <Button key="exportar" className="button-azul-radius ms-1" onClick={confirmarExportacionPlanillas}>
            Exportar
          </Button>,
        ]}
      >
        <div className="font-size-14px font-family-Montserrat-Regular">
          <p>
            Son {proyectos.length} proyecto(s): se descargan en {lotesPlanillas.length} archivos ZIP de hasta{" "}
            {TAMANO_LOTE_PLANILLAS} planillas cada uno. Si una exportación quedó a medias, elige desde qué archivo
            continuar y no se repetirán los ya descargados.
          </p>
          <div className="font-family-Monserrat-SemiBold pb-2">Empezar desde:</div>
          <Select
            style={{ width: "100%" }}
            value={loteInicial}
            onChange={(valor: number) => setLoteInicial(valor)}
          >
            {lotesPlanillas.map((lote: any[], idx: number) => (
              <Select.Option key={idx + 1} value={idx + 1}>
                {`Archivo ${idx + 1} de ${lotesPlanillas.length} — proyectos ${idx * TAMANO_LOTE_PLANILLAS + 1} a ${idx * TAMANO_LOTE_PLANILLAS + lote.length} (${lote[0]?.radicado} … ${lote[lote.length - 1]?.radicado})`}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  );
};
